<span
  [class.is-bold]="this.text().bold"
  [class.is-underline]="this.text().underline"
  [class.is-italic]="this.text().italic"
>
  {{ this.text().text }}
</span>
